const useSkeleton = () => {
  const dummyCostUnitCards = () => {
    const costUnits = [];

    for (let i = 0; i < 12; i++) {
      costUnits.push(
        <div className="tampuuri-card--item card--item--property" key={i}>
          <article>
            <div className="tampuuri-card">
              <div className="card-container-flex">
                <div className="content skeleton-line">
                  <h3 style={{ opacity: 0 }} className="sub-heading">
                    Sub heading
                  </h3>
                  <p style={{ opacity: 0 }}>Area, City</p>
                  <p style={{ opacity: 0 }}>Condition....</p>
                  <p style={{ opacity: 0 }}>Apartment types</p>
                </div>
                {dummyImage("cu_dummy" + i)}
              </div>
            </div>
          </article>
        </div>,
      );
    }
    return costUnits;
  };

  const dummyApartmentCards = () => {
    const apartments = [];

    for (let i = 0; i < 3; i++) {
      apartments.push(
        <div className="tampuuri-card--item card--item--apartment" key={i}>
          <article>
            <div className="tampuuri-card skeleton-card">
              <div className="card-container-flex">
                <div className="content skeleton-line">
                  <h3 style={{ opacity: 0 }} className="sub-heading">
                    Sub heading
                  </h3>
                  <p style={{ opacity: 0 }}>Area, City</p>
                  <p style={{ opacity: 0 }}>Condition....</p>
                  <p style={{ opacity: 0 }}>Apartment types</p>
                </div>
                {dummyImage("ap_dummy" + i)}
              </div>
            </div>
          </article>
        </div>,
      );
    }
    return apartments;
  };

  const dummyImage = (id) => {
    return (
      <div className="image-container skeleton-image">
        <img
          id={id}
          className="responsive-image img-fluid"
          loading="lazy"
          src={
            "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="
          }
          alt="Dummy image"
        />
      </div>
    );
  };

  return {
    dummyCostUnitCards: dummyCostUnitCards,
    dummyApartmentCards: dummyApartmentCards,
    dummyImage: dummyImage,
  };
};
export default useSkeleton;
